import { render } from "./Password.vue?vue&type=template&id=184453e1&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import "./Password.vue?vue&type=style&index=0&id=184453e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184453e1"]])

export default __exports__